import actionTypes from '../actionTypes';
import {
	getColumnList,
	getColumnNames,
	getColumnNamesInEnum
} from '../../components/CustomTableColumn/utils';

const initialState = {
	isDrawerOpen: false,
	isMetricsOpen: false,
	preferencesLoading: false,
	columnListLoading: false,
	userSelectedChannel: 'OMNI',
	setColumnPreferencesErrorCode: 0,
	getUserPreferencesErrorCode: 0,
	getColumnListErrorCode: 0,
	columnList: {},
	userPreferenceList: {},
	columnNames: {
		OMNI: [],
		STORE: [],
		ECOM: [],
	},
	columnNamesInEnum: {
		OMNI: [],
		STORE: [],
		ECOM: [],
	},
};

const columnReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		case actionTypes.GET_COLUMN_LIST:
			return {
				...state,
				columnListLoading: true,
				setColumnPreferencesErrorCode: 0,
			};
		case actionTypes.GET_COLUMN_LIST_SUCCESS:
			return {
				...state,
				columnListLoading: false,
				getColumnListErrorCode: 0,
				columnList: getColumnList(action?.payload?.result),
			};
		case actionTypes.GET_COLUMN_LIST_FAILURE:
			return {
				...state,
				columnListLoading: false,
				getColumnListErrorCode: action.payload,
				columnList: {},
			};
		case actionTypes.GET_USER_PREFERENCES:
			return {
				...state,
				preferencesLoading: true,
				userSelectedChannel: action?.payload?.userSelectedChannel,
			};
		case actionTypes.GET_USER_PREFERENCES_SUCCESS:
			return {
				...state,
				preferencesLoading: false,
				getUserPreferencesErrorCode: 0,
				userPreferenceList:
					action?.payload?.result || action?.payload?.metricsResponse,
				columnNames: getColumnNames(action?.payload?.result, state.columnList),
				columnNamesInEnum: getColumnNamesInEnum(action?.payload?.result, state.columnList)
			};
		case actionTypes.GET_USER_PREFERENCES_FAILURE:
			return {
				...state,
				preferencesLoading: false,
				getUserPreferencesErrorCode: action?.payload?.result,
				userPreferenceList: {},
				columnNames: getColumnNames({}, state.columnList),
				columnNamesInEnum: getColumnNamesInEnum({}, state.columnList)
			};
		case actionTypes.SET_COLUMN_PREFERENCES:
			return {
				...state,
				setColumnPreferencesErrorCode: 0,
				userPreferenceList:
					action?.payload?.request?.insightPreferences[0]?.channels,
				columnNames: getColumnNames(
					action?.payload?.request?.insightPreferences[0]?.channels,
					state.columnList
				),
				columnNamesInEnum: getColumnNamesInEnum(
					action?.payload?.request?.insightPreferences[0]?.channels,
					state.columnList
				),
			};
		case actionTypes.SET_COLUMN_PREFERENCES_FAILURE:
			return {
				...state,
				setColumnPreferencesErrorCode: action.payload,
			};
		case actionTypes.SET_COLUMN_PREFERENCES_SUCCESS:
			return {
				...state,
				setColumnPreferencesErrorCode: 200,
			};
		case actionTypes.SET_IS_DRAWER_OPEN:
			return {
				...state,
				isDrawerOpen: action.payload,
				setColumnPreferencesErrorCode: 0,
			};
		case actionTypes.SET_IS_METRICS_OPEN:
			return {
				...state,
				isMetricsOpen: action.payload,
			};
		default:
			return state;
	}
};

export default columnReducer;
